import {BaseContainerModel} from '../base-container.model';
import { bl_fi_generic_doc_intercompany_link_RowInterface, bl_fi_generic_doc_intercompany_link_RowClass } from '../../dbschema';

export class GenericDocIntercompanyLinkContainer extends BaseContainerModel{
    bl_fi_generic_doc_intercompany_link: bl_fi_generic_doc_intercompany_link_RowInterface = new bl_fi_generic_doc_intercompany_link_RowClass();   
}
